/**多語言配置說明 https://segmentfault.com/a/1190000014229902 */
export const lang ={
  Container:"箱",
     Cbm:"立方米",
      Weight:"重量",
  Balance:"结余",
  ThisYear:"今年",
  LastYear:"上年",
  Privacy_Policy:"隐私协议",
  Agree:"同意",
  user_name_not_exists:"用户名不存在",
  password_wrong:"密码错误",
  Please_set_materialtype_in_product_page:"請先到商品頁面修改設定每個商品的物料類型-成品-半成品-配件",
deleteAccount:"註銷帳號",
deleteAccountWillDeleteAllData:"註銷帳號將會刪除所有資料並無法登入",
backupDatabase:"備份資料庫",
restoreDatabase:"復原資料庫",
materialtype:"物料類型",
Manufacturing:"製造業版",
Professional:"專業版",
Standard:"標準版",
product:"成品",
halfProduct:"半成品",
components:"配件",
Parent:"父組件",
Children:"子配件",
Level:"層級",
Timing:"計時",
PieceCount:"計件",
Wages:"工價",
InternalProcess:"內部工序",
ExternalProcess:"外部工序",
ProceName:"工序名稱",
ProceIndex:"執行順序",
ChargeMan:"負責人",
BillMethod:"計費方式",
ConsumTime:"工時",
Accessories:"配件",
Assembly:"組裝",
materials:"物料",
task:"任務",
process:"工序",
BOM:"BOM",
Production:"生產",
  RestorePurchaseOneUse:"恢復購買（一個用戶(僅限於之前購買過的)",
  buy_fail_try_again:"购买失败，请重新发起购买",
  Export:'導出',
  Date:"日期",
  Chart:'图表',
  BankDetail:"銀行詳細信息",
  Seller:"賣方",
  Buver:"買方",
  Currency:"貨幣",
  CompanyName:"公司名",
  ProformaInvoice:"形式发票",
  Discount:"折扣",
  PayStatus:"支付狀態",
  ShippingStatus:"貨運狀態",
  FreightType:"運輸類型",
  Shipping:"貨運",
  Payment:"付款",
  Moneyname:"貨幣",
	Tax:"稅項",
	Freight:"貨運費",
	Insurance:"保險費",
	Bankfee:"銀行費用",
	Qc:"質量認證",
	Exchangerate:"匯率",
  Shippingnumber:"發貨單號",
	ShipDate:"發貨日期",
	Arrivedate:"到達日期",
	Grossweight:"毛重",
	CubicWeight:"立方重量",
	Totalpackages:"總包數",
  Moneytype:"貨幣類型",
	Quotedate :"報價日期",
	Validitydate:"有效日期",
	Paymentterm:"付款期限",
	Priceterm:"價格條款",
	DeliveryTerm:"交貨期限",
  BankName:"銀行名稱",
	BankAddress:"銀行地址",
	SwiftCode:"銀行代碼",
  Review:"審核",
  Signfor:"簽收",
  Finance:"財務",
  Receiver:"收貨人",
  Business:"业务",
  Profit:"利潤",
  Staff_must_use_in_browser_please_check_the_address_in_help_page:'員工必須在谷歌瀏覽器內使用，請在主服務電腦APP上幫助頁面查看ip地址，然後在其它電腦瀏覽器網址欄目輸入該地址打開登錄',
  newPassword:'新密碼',
  ForgetPassword:'忘記密碼',
  ContactUs:'联系我们/提建议',
  ContactPerson:'联系人',
  All:'全部',
  OrdernumExists:'订单号已经存在',
  PermissionDenied:'没有权限',
  StockTransfer:'库存调拨',
  FromWarehouse:'转出仓库',
  ToWarehouse:'转入仓库',
  PleaseUseInWebBrowser:'请在谷歌浏览器内使用导出Excel功能',
  PleasePrintInWebBrowser:'请在谷歌浏览器内使用打印功能',
  HistoryPrice:'歷史價格',
SerialNumber:'序列號',
    PleaseUseInWebBrowser:'請在谷歌瀏覽器內使用導出Excel功能',
  PleasePrintInWebBrowser:'请在谷歌浏览器内使用打印功能',
    Please_Use_In_APP:'請在電腦軟件內使用',
    Please_Purchase_In_APP:'請在APP內購買，不要在瀏覽器內購買',
    Connect_Postgresql_database_Default_database_is_sqlite_in_local:'可以連接Postgresql數據庫,你的數據將會存儲到Postgresql數據庫,默認使用不需要連接Postgresql數據庫,默認的是本地的Sqlite數據庫',
    Connect_Postgresql_database_data_will_store_in_Postgresql:'連接Postgresql數據庫,你的數據將會存儲到Postgresql數據庫,數據重新讀取',
    Use_sqlite_data_will_store_in_local:'使用sqlite,數據會存儲到本地機器',
    UsePostgresqlDatabase:'使用PGSQL數據庫',
    UseSqliteDatabase:'使用Sqlite數據庫',
    DatabaseName:'數據庫名稱',
    Test_connect:'測試連接',
    my:'我的',
  If_has_color_size_initstock_input_0_and_then_add_it_in_purchase:'如果商品有颜色尺码，初始库存请填写0，添加商品后在进货里录入库存',
    my_shop_qrcode_scan:'我的店鋪二維碼，提供給客戶掃碼下單，客戶手機要跟你的電腦連接同一個路由器',
    ip:'IP',
    port:'Port',
    orderstatus:'訂單狀態',
   
    Template:'模板',
    Please_select_a_excel_file:'請選擇一個文件' ,
    Please_select_only_one_excel_file:'只能選擇一個文件',
    Connect_Internet_Login_again:'連接互聯網再登錄一次再購買',
  productHasValidDate:'我的產品有有效期',
  productHasColor:'我的產品有顏色尺碼',
  GeneralGoods:'普通商品',
  Selected:'已選擇',
  RestorePurchase:'恢復購買',
  VerifyPurchase:'驗證購買',
  Buy_ElinkInvoice_one_year_use:'購買進銷存企業版一年使用權,不限用戶和設備數量',
  Buy_ElinkInvoice_Enterprise_Edition_OneUser:'購買進銷存企業版1用戶,一年（非订阅）',
  Buy_ElinkInvoice_EnterpriseEdition_Unlimited_Users:'購買進銷存企業版不限用戶和設備數量,一次性永久',
  Purchasing:'請耐心等待...',
  Validdate:'有效期',
  Makedate:'生產日期',
  Batch:'批次',
  CheckVersion:'檢查版本',
  Please_set_this_ip_address_on_App:'請在APP上設置這個IP地址,或者電腦的IP地址',
  Open_this_link_on_other_Computer_and_Phone_connect_the_same_WiFi:'在電腦或手機的谷歌瀏覽器打開這個連接(連接同一個WiFi)',
  Etit_on_top_field:'请在上方的输入框修改订单信息',
  CompanyInfo:'公司信息',
    You_need_to_purchase:'你還沒有購買,请登录再检测,請加微信聯繫 Elink9988 郵箱:bvbuy@qq.com',
    Thank_for_your_purchase:'你已經購買',
    New_version_available:'有新的版本',
    Is_the_latest_version:'是最新的版本',
  please:'請',
  input:'輸入',
  wrong:'錯誤',
  Verifycode:'驗證碼',
  You_need_to_purchase_to_continue_use:'你需要購買才能繼續使用，如果已經購買,請點擊恢復購買或驗證購買，如果已經購買請點擊取消忽視此提示,或重启软体',
  Upload:'上傳',
  Download:'下載',
  CheckBuy:'檢測購買',
  Exists:'已經存在',
  NetworkUnavailable:'網絡不可用',
  Today:'今天',
  Yesterday:'昨天',
  ThisMonth:'本月',
  LastMonth:'上月',
  nickname:'姓名',
  storeName:'公司名',
  BuyStandAlone:'購買單機版',
  PermissionDenied:'沒有權限',
  Boss:'管理員',
  login:'登錄',
  register:'註冊',
  User:'用戶',
  LoginName:'登錄名',
  username:'用戶名',
  password:'密碼',
  ok:'確定',
  cancel:'取消',
  operate:'操作',
  add:'新增',
  edit:'修改',
  success:'成功',
  fail:'失敗',
  delete:'刪除',
  refresh:'刷新',
  close:'取消',
  back:'返回',
  ElinkInvoice:'移聯進銷存',
  Purchase :' 進貨',
  BaseData :' 基礎數據',
  Sell :'銷售',
  PurchaseReturns:'採購退貨',
  SellReturns:'銷售退貨',
  transIn:"调入",
transOut:"调出",
  Inventory:'庫存',
  Statistics:'統計',
  Orders:'訂單',
  StockTransfer:'庫存調入',
  StockRecall:'庫存調出',
  Customer:'客戶',
  Supplier:'供應商',
  Warehouse:'倉庫',
  Color:'顏色',
  Size:'尺碼',
  Category:'分類',
  Category2:'分類2',
  Product:'商品',
  Account:'流水賬',
  AccountType:'流水賬分類',
  Staff:'員工',
  typeone:'品類',
  typetwo:'子品類',
  ProductName:'品名',
  Specification:'規格',
  Barcode:'編號',
  Buyprice:'採購價',
  Sellprice:'銷售價',
  Wholesaleprice:'批發價',
  Currentstock:'當前庫存',
  Unit:'單位',
  Parameter:'參數',
  Remark:'備註',
  Supplier:'供應商',
  Customer:'客戶',
  Staff:'員工',
  Receivable:'應收',
  Receipts:'實收',
  Payable:'應付',
  Paid:'實付',
  Overdraft:'欠款',
  Initstock:'初始庫存',

  DateDay:'日期',
  Preferential:'優惠',
  OrderNum:'單號',
  Password:'登錄密碼',
  UserName:'名稱',
  IdNum:'省份證號',
  BirthDay:'生日',
  SEX:'性別',
  Female:'女',
  Male:'男',
  Name:'名稱',
  Address:'地址',
  Phone:'電話',
  Email:'郵箱',
  CardNum:'銀行卡號',
  Price:'價格',
  QTY:'數量',
  Select:'請選擇',
  SupplierCategory:'供應商分類',
  CustomerCategory:'客戶分類',
  Power:'權限',
  Role:'角色',
  save:'保存',
  image:'圖片',
  search:'搜索',
  Year:'年',
  Month:'月',
  Day:'日',
  Total:'合計',
  WorkReport:'工作報告',
  Leave:'請假',
  CheckIn:'簽到',
  Title:'標題',
  News:'新聞',
  Announcement:'公告',
  Approval:'審批',
  Tracking:'軌跡跟踪',
  Bill:'流水賬',
  OrdersDetail:'訂單明細',
  Expense:'支出',
  Income:'收入',
  Userfor:'用途',
  Amount:'金額',
  SelectFile:'選擇文件',
  Content:'內容',
  Cost:'金額',
  ApprovalUser:'審核用戶',
  ApprovalStatus:'審核狀態',
  ApprovalRemark:'審核備註',
  ApprovalDate:'審核日期',
  Submit:"提交",
  SubmitDate:'提交日期',
  Status:'狀態',
  FromDateTime:'開始時間',
  ToDateTime:'結束時間',
  Subject:'內容',
  Latitude:'緯度',
  Longitude:'經度',
  Print:'打印',
  DataTrans:'數據傳輸',
  OA:'移動辦公',
  Setting:'設置',
  Help:'幫助',
  ScanOpenInPhone:'掃描在手機打開使用',
  Building:'大樓',
  Room:'房間',
  HotelCheckIn:'入住',
  CheckOut:'退房',
  Hotel:'酒店',
  Checkintime:'入住時間',
  Checkouttime:'退房時間',
  Deposit:'押金',
  Cost:'費用',
  RoomNum:'房號',
  Rent:'房租',
  costday:'繳費日期',
  rent:'租金',
  waternum:'水錶讀數',
  electricnum:'電錶讀數',
  gasnum:'煤氣表讀數',
  watercost:'水費',
  electriccost:'電費',
  gascost:'煤氣費',
  cleaningcost:'清潔費',
  networkcost:'網絡費',
  tvcost:'電視費',
  managecost:'管理費',
  othercost:'其它費用',
  totalcost:'總共',
  remark:'備註',
  addtime:'添加日期',
  OpenInBrowser:'在瀏覽器打開',
  InventoryProfit:'庫存盤盈',
  InventoryLoss:'庫存盤虧',
  Buy:'購買',
  Refresh:'刷新',
  Add:'添加',
  Search:'搜索',
  Records:'條',
  }



// WEBPACK FOOTER //
// ./src/lang/zh-TW.js